import ShopList from "../components/shops/ShopList.jsx";



export default function Home() {

  return (
    <>
     
      <ShopList />
    </>
  );
}
